module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_NB-3d4c9181799e7dc939d47ad5428fed24.svg";